export function getUsedStorageBarWidth(used, total) {
    var width = (used / total) * 100;
    return width > 0 && width < 1
        ? Number(width.toFixed(2))
        : Math.floor(width);
}
//# sourceMappingURL=getUsedStorageBarWidth.js.map